import * as yup from 'yup'

export const schemaCreateContractProcessModal = yup.object().shape({
    contract: yup.object().shape({
        contract_process_title: yup.string().required(),
        contract_process_content: yup
            .string()
            .required('subcontract-name-validate'),
        contract_process_problem: yup.string().required(),
        contract_process_deadline: yup.string().required(),
        contract_process_assignees: yup.array().required(),
        contract_process_priority: yup.string().required(),
    }),
})
